import React from "react";
import AssetsUtil from "../util/AssetsUtil";
import clsx from "clsx";

const styles = require("./styles/Icon.css");

type IconSourceProps =
	| {iconName: string}
	| {iconImgPath: string}
	| {chapterNumber: number}
	| {gradeNumber: number};

type IconProps = IconSourceProps & {className?: string; color?: string};

export const Icon = ({className, color, ...props}: IconProps) => {
	let buttonSrc;
	const colorSuffix = color ? `-${color}` : "";
	// TODO: we validate the prop after checking for existence because, when used
	// in a legacy context, all of these props are passed in.  Once all usages
	// are updated, we can remove the additional validation.
	if ("iconImgPath" in props && props.iconImgPath) {
		buttonSrc = props.iconImgPath;
	} else if ("iconName" in props && props.iconName) {
		buttonSrc = AssetsUtil.getButton(props.iconName, color);
	} else if ("chapterNumber" in props && props.chapterNumber) {
		buttonSrc = `${global.BASE_URL}assets/images/icons/level/chapter-${props.chapterNumber}${colorSuffix}.svg`;
	} else if ("gradeNumber" in props && props.gradeNumber) {
		buttonSrc = `${global.BASE_URL}assets/images/icons/level/grade-${props.gradeNumber}${colorSuffix}.svg`;
	}

	return (
		<img className={clsx(styles.image, className, "cheese")} src={buttonSrc} />
	);
};
